import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { useCheckUserGroupsAccess } from '../../../Auth/hooks/useCheckUserGroupsAccess';
import { AuthContext } from '../../../Auth/contexts/AuthContext';

const RedirectToDefault = () => {
    const authContext = useContext(AuthContext);

    const hasExplorerPermissions = useCheckUserGroupsAccess(['explorer_tiktok_viewer']);
    const isTrndsClientUser = useCheckUserGroupsAccess(['trnds_client']);
    if (typeof hasExplorerPermissions !== 'boolean' || typeof isTrndsClientUser !== 'boolean') {
        return null;
    }

    const defaultPage = (() => {
        if (!authContext.authenticated) {
            return '/sign-in/';
        }

        if (isTrndsClientUser) {
            return '/client/explorer/songs/';
        }

        return hasExplorerPermissions ? '/explorer/tiktok/audio/' : '/collections/tiktok/';
    })();

    return <Navigate to={defaultPage} replace />;
};

export default RedirectToDefault;
